var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 53,
    viewBox: "0 0 92 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 91,
    height: 52,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 2,
    rx: 1,
    transform: "matrix(1 0 0 -1 37.5 17.5)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 2,
    rx: 1,
    transform: "matrix(1 0 0 -1 37.5 27.5)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 2,
    rx: 1,
    transform: "matrix(1 0 0 -1 37.5 37.5)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 8.5,
    width: 27,
    height: 36,
    rx: 4,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate2);
export default __webpack_public_path__ + "static/media/certificate2.12abbb03ae8fb6258fd1aac6678ce38f.svg";
export { ForwardRef as ReactComponent };